(() => {
  const createCard = () => {
    const canvas = document.createElement('canvas');
    canvas.width = 1080; canvas.height = 1080;
    const context = canvas.getContext('2d');
    if (!context) return null;
    const background = context.createLinearGradient(0, 0, 1080, 1080);
    background.addColorStop(0, '#f4633a'); background.addColorStop(1, '#ad241d');
    context.fillStyle = background; context.fillRect(0, 0, 1080, 1080);
    context.textAlign = 'center'; context.fillStyle = '#ffffff';
    context.font = '800 56px sans-serif'; context.fillText('✷ BOLD ✷', 540, 220);
    context.font = '900 94px sans-serif';
    ['HOJE É MEU DIA', 'COM A BOLD'].forEach((line, index) => context.fillText(line, 540, 475 + index * 120));
    context.font = '40px sans-serif'; context.fillText('Uma nova volta ao sol merece sabor de sobra.', 540, 825);
    return canvas;
  };
  const downloadCard = (canvas) => {
    const link = document.createElement('a'); link.href = canvas.toDataURL('image/png');
    link.download = 'meu-dia-com-a-bold.png'; link.click();
  };
  const init = (root) => {
    if (root.dataset.digiBdayReady) return;
    root.dataset.digiBdayReady = 'true';
    root.querySelector('[data-digi-bday-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      try {
        await navigator.clipboard.writeText(button.dataset.digiBdayCopy);
        button.textContent = 'CÓDIGO COPIADO!';
      } catch {
        button.textContent = 'Não foi possível copiar';
      }
    });
    root.querySelector('[data-digi-bday-share]')?.addEventListener('click', async () => {
      const canvas = createCard();
      if (!canvas) return;
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      if (!blob) return downloadCard(canvas);
      const file = new File([blob], 'meu-dia-com-a-bold.png', { type: 'image/png' });
      const data = { files: [file], title: 'Hoje é meu dia com a BOLD', text: 'Hoje é meu dia com a BOLD! ✷' };
      if (navigator.canShare?.({ files: [file] }) && navigator.share) {
        try { await navigator.share(data); } catch (error) { if (error.name !== 'AbortError') downloadCard(canvas); }
      } else downloadCard(canvas);
    });
    root.querySelector('[data-digi-bday-download]')?.addEventListener('click', () => {
      const canvas = createCard();
      if (canvas) downloadCard(canvas);
    });
  };
  const syncPreview = () => {
    if (!window.Shopify?.designMode) return;
    const hero = document.querySelector('[data-digi-bday-hero]');
    if (!hero) return;
    const audience = hero.dataset.audience;
    document.querySelectorAll('[data-digi-bday-preview-section]').forEach((section) => {
      const content = section.querySelector('[data-digi-bday-preview-content]');
      const template = section.querySelector(`template[data-digi-bday-preview-audience="${audience}"]`);
      if (!content || !template || content.dataset.audience === audience) return;
      content.replaceChildren(template.content.cloneNode(true));
      content.dataset.audience = audience;
    });
  };
  const start = () => {
    syncPreview();
    document.querySelectorAll('[data-digi-bday]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();

